<template>
  <div class="modal">
    <div class="background"></div>
    <div class="box">
      <span class="popup-title--blue"
        >Did you like this Trivia? Tell us what you think!</span
      >
      <div class="thumbs-region">
        <FontAwesomeIcon
          v-for="(option, index) in wouldPlayAgainOptions"
          :key="index"
          class="thumb"
          :class="{ 'thumb--selected': option.isSelected }"
          :icon="option.isSelected ? option.selectedIcon : option.icon"
          @click="receiveThumbSelected(index)"
        />
      </div>
      <label class="pure-material-textfield-outlined">
        <input placeholder="(Optional)" type="text" v-model="feedback" />
        <span>Comment</span>
      </label>
      <button
        :disabled="!hadGivenFeedback"
        @click="closeModal(feedback)"
        class="confirm"
        :class="{ disabled: !hadGivenFeedback }"
      >
        Send
      </button>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { faThumbsUp, faThumbsDown } from "@fortawesome/free-regular-svg-icons";
import {
  faThumbsUp as faThumbsUpSelected,
  faThumbsDown as faThumbsDownSelected,
} from "@fortawesome/free-solid-svg-icons";
import { sendFeedback } from "../utils/feedback";
export default {
  data: () => ({
    wouldPlayAgain: "",
    feedback: "",
    wouldPlayAgainOptions: [
      {
        isSelected: false,
        icon: faThumbsUp,
        selectedIcon: faThumbsUpSelected,
      },
      {
        isSelected: false,
        icon: faThumbsDown,
        selectedIcon: faThumbsDownSelected,
      },
    ],
  }),
  computed: {
    ...mapState(["playerEmail", "playerName"]),
    hadGivenFeedback() {
      return this.wouldPlayAgainOptions.some((item) => item.isSelected);
    },
  },
  methods: {
    handleCallback(err, records) {
      if (err) {
        return { statusCode: err.statusCode, error: err.message };
      }
      this.$emit("closeModal", err);
      records.forEach(function(record) {
        return {
          statusCode: 201,
          result: `Feedback ${record.getId()} sent`,
        };
      });
    },
    closeModal() {
      sendFeedback(
        this.playerName,
        this.feedback,
        this.playerEmail,
        this.wouldPlayAgain,
        this.handleCallback
      );
      let eventName =
        process.env.VUE_APP_ANALYTICS_EVENT_BASE + "WouldPlayAgainFeedback";
      this.$logEvent(eventName, {
        wouldPlayAgain: this.wouldPlayAgain,
      });
      /**let eventName =
        process.env.VUE_APP_ANALYTICS_EVENT_BASE + "WouldPlayAgainFeedback";
      this.$logEvent(eventName, {
        wouldPlayAgain: this.wouldPlayAgainOptions[0].isSelected,
      });**/
    },
    receiveThumbSelected(index) {
      for (let i = 0; i < this.wouldPlayAgainOptions.length; i++) {
        this.wouldPlayAgainOptions[i].isSelected = index == i;
        this.wouldPlayAgain = index === 0 ? "Like" : "Dislike";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../scss/variables.scss";
@import "../scss/common.scss";

::placeholder {
  color: $primary;
  opacity: 0.6;
}

.modal {
  position: absolute; /* Stay in place */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto;
  display: flex;
  justify-content: center;
  align-items: center;
}

.background {
  position: absolute; /* Stay in place */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  background-color: rgb(0, 0, 0); /* Fallback color */
  background-color: rgba(0, 0, 0, 0.4); /* Black w/ opacity */
}

.box {
  background-color: $quaternary-lighter;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 1rem;
  border-radius: 0.5rem;
  margin: 2rem;
}

.popup-title--blue {
  font-family: $primary-font;
  font-style: normal;
  font-weight: bold;
  font-size: 1rem;
  text-align: center;
  color: $primary;
  margin: 1rem auto;
}

.thumbs-region {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: baseline;
}

.thumb {
  color: $primary;
  background: white;
  margin: 0 0.5rem 1rem;
}

.thumb--selected {
  font-size: 1.5rem;
  transition: linear 0.2s;
}

.pure-material-textfield-outlined {
  position: relative;
  display: inline-block;
  padding-top: 6px;
  font-family: $primary-font;
  font-size: 1rem;
  overflow: hidden;
}

/* Input, Textarea */
.pure-material-textfield-outlined > input,
.pure-material-textfield-outlined > textarea {
  cursor: text;
  box-sizing: border-box;
  margin: 0;
  border: solid 1px; /* Safari */
  border-color: $primary;
  border-top-color: transparent;
  border-radius: 4px;
  padding: 15px 13px 15px;
  width: 100%;
  height: inherit;
  color: $primary;
  background-color: transparent;
  box-shadow: none; /* Firefox */
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
  caret-color: $primary;
  transition: border 0.2s, box-shadow 0.2s;
}

/* Span */
.pure-material-textfield-outlined > input + span,
.pure-material-textfield-outlined > textarea + span {
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  border-color: $primary;
  width: 100%;
  max-height: 100%;
  color: $primary;
  font-size: 75%;
  line-height: 15px;
  cursor: text;
  transition: color 0.2s, font-size 0.2s, line-height 0.2s;
}

/* Corners */
.pure-material-textfield-outlined > input + span::before,
.pure-material-textfield-outlined > input + span::after,
.pure-material-textfield-outlined > textarea + span::before,
.pure-material-textfield-outlined > textarea + span::after {
  content: "";
  display: block;
  box-sizing: border-box;
  margin-top: 6px;
  border-top: solid 1px;
  border-top-color: $primary;
  min-width: 10px;
  height: 8px;
  pointer-events: none;
  box-shadow: inset 0 1px transparent;
  transition: border-color 0.2s, box-shadow 0.2s;
}

.pure-material-textfield-outlined > input + span::before,
.pure-material-textfield-outlined > textarea + span::before {
  margin-right: 4px;
  border-left: solid 1px transparent;
  border-radius: 4px 0;
}

.pure-material-textfield-outlined > input + span::after,
.pure-material-textfield-outlined > textarea + span::after {
  flex-grow: 1;
  margin-left: 4px;
  border-right: solid 1px transparent;
  border-radius: 0 4px;
}

/* Placeholder-shown and on focus */
.pure-material-textfield-outlined > input:placeholder-shown,
.pure-material-textfield-outlined > textarea:placeholder-shown {
  border-color: $primary;
  border-top-color: transparent;
  outline: none;
}

.pure-material-textfield-outlined > input:placeholder-shown + span,
.pure-material-textfield-outlined > textarea:placeholder-shown + span {
  color: $primary;
}

.pure-material-textfield-outlined > input:placeholder-shown + span::before,
.pure-material-textfield-outlined > textarea:placeholder-shown + span::before,
.pure-material-textfield-outlined > input:placeholder-shown + span::after,
.pure-material-textfield-outlined > textarea:placeholder-shown + span::after {
  border-top-color: $primary;
}

/* Disabled */
.pure-material-textfield-outlined > input:disabled,
.pure-material-textfield-outlined > input:disabled + span,
.pure-material-textfield-outlined > textarea:disabled,
.pure-material-textfield-outlined > textarea:disabled + span {
  border-color: $primary;
  border-top-color: transparent;
  color: $primary;
  pointer-events: none;
}

.pure-material-textfield-outlined > input:disabled + span::before,
.pure-material-textfield-outlined > input:disabled + span::after,
.pure-material-textfield-outlined > textarea:disabled + span::before,
.pure-material-textfield-outlined > textarea:disabled + span::after {
  border-top-color: $primary;
}

.pure-material-textfield-outlined > input:disabled:placeholder-shown,
.pure-material-textfield-outlined > input:disabled:placeholder-shown + span,
.pure-material-textfield-outlined > textarea:disabled:placeholder-shown,
.pure-material-textfield-outlined > textarea:disabled:placeholder-shown + span {
  border-top-color: $primary;
}

.pure-material-textfield-outlined
  > input:disabled:placeholder-shown
  + span::before,
.pure-material-textfield-outlined
  > input:disabled:placeholder-shown
  + span::after,
.pure-material-textfield-outlined
  > textarea:disabled:placeholder-shown
  + span::before,
.pure-material-textfield-outlined
  > textarea:disabled:placeholder-shown
  + span::after {
  border-top-color: transparent;
}

/* Faster transition in Safari for less noticable fractional font-size issue */
@media not all and (min-resolution: 0.001dpcm) {
  @supports (-webkit-appearance: none) {
    .pure-material-textfield-outlined > input,
    .pure-material-textfield-outlined > input + span,
    .pure-material-textfield-outlined > textarea,
    .pure-material-textfield-outlined > textarea + span,
    .pure-material-textfield-outlined > input + span::before,
    .pure-material-textfield-outlined > input + span::after,
    .pure-material-textfield-outlined > textarea + span::before,
    .pure-material-textfield-outlined > textarea + span::after {
      transition-duration: 0.1s;
    }
  }
}
</style>
